var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-nowrap place-items-start"},[_c('div',{staticClass:"w-full"},[_c('nav',[_c('div',{staticClass:"flex flex-row gap-4 items-center"},[_c('div',{staticClass:"menu",class:{
              active: decodeURI(_vm.$page.url).includes('delivery_method=regular'),
            }},[_c('Link',{attrs:{"href":_vm.route('admin.free_shipping') + '?delivery_method=regular'}},[_vm._v("一般物流")])],1),_vm._v(" "),_c('div',{staticClass:"menu",class:{
              active: decodeURI(_vm.$page.url).includes(
                'delivery_method=711'
              ),
            }},[_c('Link',{attrs:{"href":_vm.route('admin.free_shipping') + '?delivery_method=711'}},[_vm._v("7-11 店到店")])],1)])]),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }